import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Hidden from '@material-ui/core/Hidden'
import Collapse from '@material-ui/core/Collapse'
import withStyles from '../styles/withStyles'
import WPList from '../WPList'
import Typography from '../Typography'

export const styles = theme => ({
  root: {
    width: '100%',
    padding: `13px 0`,
    border: `1px solid ${theme.palette.blue[200]}`,
    [theme.breakpoints.up('md')]: {
      border: 'none',
    },
  },
  expanded: {
    paddingBottom: theme.utils.spacing(6),
  },
  list: {
    margin: `${theme.utils.spacing(8)} ${theme.utils.spacing(
      2,
    )} 0 ${theme.utils.spacing(2)}`,
    [theme.breakpoints.up('md')]: {
      margin: `0 ${theme.utils.spacing(8)} 0 ${theme.utils.spacing(2)}`,
    },
  },
  title: {
    textAlign: 'center',
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.utils.spacing(4),
      textAlign: 'left',
      cursor: 'auto',
    },
  },
})

const TopSources = props => {
  const { children, classes, className: classNameProp, ...other } = props
  const [expanded, setExpanded] = useState(false)
  const onToggle = () => setExpanded(!expanded)

  const className = classnames(
    classes.root,
    { [classes.expanded]: expanded },
    classNameProp,
  )

  return (
    <div className={className} {...other}>
      <Hidden implementation="css" smDown>
        <Typography variant="h3" className={classes.title}>
          Top Sources
        </Typography>
        <WPList className={classes.list}>{children}</WPList>
      </Hidden>
      <Hidden implementation="css" mdUp>
        <Typography variant="h3" className={classes.title} onClick={onToggle}>
          Top Sources
        </Typography>
        <Collapse in={expanded}>
          <WPList className={classes.list}>{children}</WPList>
        </Collapse>
      </Hidden>
    </div>
  )
}

TopSources.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
}

TopSources.uiName = 'TopSources'

export default withStyles(styles)(TopSources)
